import React from "react"
import { HeaderMain, Wrapper, Logo, Image, SearchContainer, Nav, NavLink, SearchBox, SearchInput, SearchIcon } from "./styles/header"
import { Container } from "../../containers"
import { Icon } from "../../components"

export default function Header({ children, ...rest }) {
  return <HeaderMain {...rest}>{children}</HeaderMain>
}

Header.Wrapper = function HeaderWrapper({ children, ...rest }) {
  return (
    <Container>
      <Wrapper {...rest}>{children}</Wrapper>
    </Container>
  )
}

Header.Logo = function HeaderLogo({ children, path, ...rest }) {
  return (
    <Logo {...rest}>
      <Image {...rest} src="https://raw.githubusercontent.com/MajorCoding/Logos/main/themoviebase-logo.svg" />
    </Logo>
  )
}

Header.SearchContainer = function HeaderSearchContainer({ children, ...rest }) {
  return <SearchContainer {...rest}>{children}</SearchContainer>
}

Header.SearchBox = function HeaderSearchBox({ children, ...rest }) {
  return <SearchBox {...rest}>{children}</SearchBox>
}

Header.SearchInput = function HeaderSearchInput({ children, ...rest }) {
  return <SearchInput {...rest} />
}

Header.SearchIcon = function HeaderSearchIcon({ name, ...rest }) {
  return <SearchIcon {...rest} className={name} />
}

Header.Nav = function HeaderNav({ children, ...rest }) {
  return <Nav {...rest}>{children}</Nav>
}

Header.NavLink = function HeaderNavLink({ children, icon, to, ...rest }) {
  return (
    <NavLink {...rest} to={to}>
      <Icon name={icon} />
      <p>{children}</p>
    </NavLink>
  )
}
